@use '~/theme/theme' as *;

.iconTrigger {
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.disclosureHeading {
  display: flex;
  justify-content: space-between;
  border: none;
  background-color: transparent;
  padding-top: spacing(2);
  padding-bottom: spacing(2);
  width: 100%;
  font-weight: 600;
  align-items: center;
  font-family: 'Public Sans', sans-serif;
  text-align: left;

  &.trigger {
    cursor: pointer;
  }
}

.trigger {
  cursor: pointer;

  svg {
    margin-right: 8px;
    transition: transform 0.3s ease;
    flex-shrink: 0;
  }

  &[aria-expanded='true'] svg {
    transform: rotate(180deg);
  }
}

.disclosurePanel {
  border-bottom: border(grey-400);

  &[aria-hidden='false'] {
    padding-bottom: spacing(2);
  }

  &.noBorder {
    border-bottom: none;
  }
}
